import SearchPivotsContainer from './SearchResultsPivotsContainer';

export default SearchPivotsContainer;
